import * as React from 'react';

import { Select, StyleSheet, color, css, font } from '@coursera/coursera-ui';

type Props = {
  enableErrorState: boolean;
  options: Array<any>;
  onChange: (x: { ids: Array<string> }) => void;
};

type State = {
  ids: Array<string>;
};

const styles = StyleSheet.create({
  checkboxDropdown: {
    fontSize: font.sm,
  },
  errorState: {
    color: color.danger,
    border: `2px solid ${color.danger}`,
  },
});

class CheckboxDropdown extends React.Component<Props, State> {
  state = {
    ids: [],
  };

  handleSelect = (selectedOptions: Array<{ label: string; value: string }>) => {
    const ids = selectedOptions.map((option) => option.value);

    this.setState({ ids });
    this.props.onChange({ ids });
  };

  render() {
    const { options, enableErrorState } = this.props;

    return (
      <div {...css(styles.checkboxDropdown, enableErrorState && styles.errorState)}>
        <Select options={options} onChange={this.handleSelect} multi={true} value={this.state.ids} />
      </div>
    );
  }
}

export default CheckboxDropdown;
